module.exports = "https://static.wmbcdn.com/uniweb/images/3d6a56a945290fd8af53a97baa0ac808.svg";